__turbopack_context__.v({
  "accordionBtn": "LocalCityLandingPage-module__lC1OGq__accordionBtn",
  "accordionBtnActive": "LocalCityLandingPage-module__lC1OGq__accordionBtnActive",
  "accordionContent": "LocalCityLandingPage-module__lC1OGq__accordionContent",
  "accordionSingle": "LocalCityLandingPage-module__lC1OGq__accordionSingle",
  "accordionWrapper": "LocalCityLandingPage-module__lC1OGq__accordionWrapper",
  "body": "LocalCityLandingPage-module__lC1OGq__body",
  "bodyImage": "LocalCityLandingPage-module__lC1OGq__bodyImage",
  "bodySection": "LocalCityLandingPage-module__lC1OGq__bodySection",
  "bottomForm": "LocalCityLandingPage-module__lC1OGq__bottomForm",
  "ctaButton": "LocalCityLandingPage-module__lC1OGq__ctaButton",
  "formAnchor": "LocalCityLandingPage-module__lC1OGq__formAnchor",
  "formCard": "LocalCityLandingPage-module__lC1OGq__formCard",
  "hero": "LocalCityLandingPage-module__lC1OGq__hero",
  "heroContainer": "LocalCityLandingPage-module__lC1OGq__heroContainer",
  "heroCopy": "LocalCityLandingPage-module__lC1OGq__heroCopy",
  "heroFormColumn": "LocalCityLandingPage-module__lC1OGq__heroFormColumn",
  "heroGrid": "LocalCityLandingPage-module__lC1OGq__heroGrid",
  "heroSubtitle": "LocalCityLandingPage-module__lC1OGq__heroSubtitle",
  "heroTitle": "LocalCityLandingPage-module__lC1OGq__heroTitle",
  "hubspotForm": "LocalCityLandingPage-module__lC1OGq__hubspotForm",
  "iframe": "LocalCityLandingPage-module__lC1OGq__iframe",
  "iframeWrap": "LocalCityLandingPage-module__lC1OGq__iframeWrap",
  "imageBlock": "LocalCityLandingPage-module__lC1OGq__imageBlock",
  "page": "LocalCityLandingPage-module__lC1OGq__page",
  "ratingStars": "LocalCityLandingPage-module__lC1OGq__ratingStars",
  "ratingText": "LocalCityLandingPage-module__lC1OGq__ratingText",
  "splitRow": "LocalCityLandingPage-module__lC1OGq__splitRow",
  "splitRowLeft": "LocalCityLandingPage-module__lC1OGq__splitRowLeft",
  "splitRowRight": "LocalCityLandingPage-module__lC1OGq__splitRowRight",
  "star": "LocalCityLandingPage-module__lC1OGq__star",
});
